import axios from 'axios';

import { API_URL_NEW } from '../lib/endpoints'
import { prepareSelectParam, prepareFilterParam } from '../lib/queryParams';
import { ALLOWED_QUERY_OPERATOR, FUNDING_STATUS, TAXONOMIES, ENTITY_TYPE } from '/src/lib/constants';

export default {

    getPrivateEquity: (filters, page, limit, sort, signal) => {
        const fields = prepareSelectParam(['id', 'name', 'code', 'description', 'logo_data', 'hq_data', 'entity_type', 'investment_vehicle_data', 'number_of_rounds_raised', 'investors_data'])
        const url = `${API_URL_NEW}/pe-companies?fields=${fields}&filters=${filters}&page=${page}&limit=${limit}&sort=${sort}`;
        return axios.get(url, { signal })
    },

    getPrivateEquityEntityCount: (filters) => {
        const url = `${API_URL_NEW}/pe-companies/setting/count?filters=${filters}`;
        return axios.get(url)
    },

    /* this is similar to the function above, but is specifically for landing / content pages as we need to specify a static backup value in case of API error */
    getStaticPECompanyCount: () => {
        const url = `${API_URL_NEW}/pe-companies/setting/count`;

        return new Promise((resolve, reject) => {
            axios.get(url).then(async (response) => {
                if (response.data.status === 200) {
                    resolve(response.data.data);
                } else {
                    let error = new Error(response);
                    throw error;
                }
            }).catch(err => {
                let data = {
                    error: err,
                    // set static value in case of error
                    totalCount: "1,881"
                }
                console.log("ERROR: ", err);
                reject(data);
            })
        })
    },

    getPETransactionsCount: () => {
        const filters = prepareFilterParam([
            { 
                key: 'verification_status', 
                value: [FUNDING_STATUS.draft], 
                op: ALLOWED_QUERY_OPERATOR.notEq 
            },
            { 
                key: 'funding_stage_type_filter', 
                value: [TAXONOMIES.peFundingStage], 
                op: ALLOWED_QUERY_OPERATOR.equal 
            },
            { 
                key: 'investedin_type_filter', 
                value: [ENTITY_TYPE.startup, ENTITY_TYPE.corporate], 
                op: ALLOWED_QUERY_OPERATOR.equal 
            },
        ]);

        const url = `${API_URL_NEW}/funding-breakdown/setting/count?filters=${filters}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then(async (response) => {
                if (response.data.status === 200) {
                    resolve(response.data.data);
                } else {
                    let error = new Error(response);
                    throw error;
                }
            }).catch(err => {
                let data = {
                    error: err,
                    // set static value in case of error
                    totalCount: "1,890"
                }
                console.log("ERROR: ", err);
                reject(data);
            })
        })
    },

    getPEInvestorsCount: () => {
        const filters = prepareFilterParam([
            {
                key: 'investment_type_filter',
                op: ALLOWED_QUERY_OPERATOR.equal,
                value: [TAXONOMIES.peFundingStage]
            }
        ]);

        const url = `${API_URL_NEW}/ecosystem/setting/count?filters=${filters}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then(async (response) => {
                if (response.data.status === 200) {
                    resolve(response.data.data);
                } else {
                    let error = new Error(response);
                    throw error;
                }
            }).catch(err => {
                let data = {
                    error: err,
                    // set static value in case of error
                    totalCount: "736"
                }
                console.log("ERROR: ", err);
                reject(data);
            })
        })
    },

}
